// extracted by mini-css-extract-plugin
module.exports = {"squareOne":"home_squareOne__3YqFZ","menuGridContainer":"home_menuGridContainer__2jgih"};